import React, { useEffect, useState } from "react";
import { axiosPost } from "../../../utils/AxiosApi";
import { URL as url } from "../../../utils/Constants";

export const useTemplatesGallery = () => {
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);

  const getAllTemplates = () => {
    setLoading(true);
    axiosPost(
      url.getAllTemplates,
      {},
      (response) => {
        if (response?.status === 200) {
          let data = response.data.data;
          data.forEach((t) => {
            // assuming t.content has the HTML string
            const blob = new Blob([t.templateFormat], { type: "text/html" });
            t.url = URL.createObjectURL(blob); // assign blob URL
          });
          setTemplates(data || []);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
      },
    );
  };

  useEffect(() => {
    getAllTemplates();
  }, []);

  return { loading, templates };
};
